<template>
  <v-layout
    class="pa-4"
    v-if="amount.total"
    column
  >
    <v-layout justify-space-between row>
      <v-flex class="header ml-5">
        <h1 class="title -tongue">
          Olá, <strong>{{ username }}</strong>.
          Você tem {{ amount.total }} boleto{{ amount.total !== 1 ? 's' : '' }}:
        </h1>
      </v-flex>
    </v-layout>

    <v-layout row justify-start class="mt-4">
      <v-layout align-center>
        <filter-cards
          v-if="amount.total"
          @changeActive="toggleActive"
          :cards="cards"
        />
      </v-layout>
    </v-layout>
  </v-layout>
</template>

<script>
import FilterCards from '@/components/application/list/FilterCards';
import colors from 'vuetify/es5/util/colors';
import { isEqual, findIndex } from 'lodash';

export default {
  name: 'PaymentSlipsHeader',
  components: {
    FilterCards,
  },
  data() {
    return {
      username: JSON.parse(localStorage.getItem('user')).name,
    };
  },
  props: {
    payment_slips: {
      type: Array,
      default: () => [],
    },
    activeStatus: {
      type: String,
      default: '',
    },
    amount: {
      type: Object,
    }
  },
  methods: {
    toggleActive(card) {
      const newActiveItemIndex = findIndex(this.cards, ['title', card.title]);
      this.cards[newActiveItemIndex].active = true;
      this.$emit('activeStatusChanged', card.status);
    },
  },
  computed: {
    cards() {
      return [
        {
          title: 'TODOS',
          status: '',
          amount: this.amount.total,
          borderColor: colors.grey.base,
          backgroundColor: colors.grey.lighten2,
          active: isEqual(this.activeStatus, ''),
        },
        {
          title: 'PENDENTE',
          status: 'pending',
          amount: this.amount.pending,
          borderColor: colors.amber.base,
          backgroundColor: colors.amber.lighten5,
          active: isEqual(this.activeStatus, 'pending'),
        },
        {
          title: 'PAGO',
          status: 'paid',
          amount: this.amount.paid,
          borderColor: colors.green.base,
          backgroundColor: colors.green.lighten5,
          active: isEqual(this.activeStatus, 'paid'),
        },
        {
          title: 'VENCIDO',
          status: 'expired',
          amount: this.amount.expired,
          borderColor: colors.red.base,
          backgroundColor: colors.red.lighten5,
          active: isEqual(this.activeStatus, 'expired'),
        },
      ];
    },
    isAdmin(){
      return this.$route.meta.userType === 'Admin';
    },
  },
};
</script>